import { Controller } from 'react-hook-form'
import SectionForm, { getFormField, useFormContext } from "../SectionForm"

import AcquereurFields from "./AcquereurFields"
import SuggestionNotaire from "./SuggestionNotaire"

const FieldList = [
  // Partie 1
  {name: "prix_vente", label: "Prix de vente", type: "currency"},
  {name: "marge", label: "Marge", type: "currency"},
  {name: "vente_montant_honoraires_ttc", label: "Honoraires TTC", type: "currency"},
  {name: "montant_net_vendeur", label: "Net vendeur", type: "currency"},
  // Partie 2 acquéreurs
  // {name: "acquereurs"},
  // étant un champ avec suggestions, il est ajouté à la liste après coup 
  // pour éviter les re-render en boucle.
  // Partie 3
  // {name: "notaire_vendeur", label: "Notaire vendeur" },
  // {name: "notaire_acquereur", label: "Notaire acquéreur"},
  {name: "date_signature_compromis", label: "Date compromis", type: 'date'},
  {name: "date_signature_acte", label: "Date signature", type: 'date'},
  {name: "date_releve_compteur", label: "Date relevé compteur", type: 'date'},
]

// typeBien est passé en props car SectionForm
// ne crée les values dans le form que pour les fields définis
const FormContent = () => {
  const { control, getValues, formErrors, errors } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-center gap-4">                
        {FieldList.slice(0, 4).map( 
          (field, index) => getFormField(control, field, index) 
        )}
      </div>
      <div className="flex flex-col items-center gap-4">                
        <AcquereurFields control={control} formErrors={formErrors} apiErrors={errors} />
      </div>
      <div className="flex flex-col items-center gap-4">
        <Controller 
          name="notaire_vendeur"
          control={control}
          defaultValue=""
          render={({field}) => (
            <SuggestionNotaire 
              label="Notaire vendeur"
              objectField={field} 
              originalData={getValues('notaire_vendeur') || ""} 
            />
          )}
        />
        <Controller 
          name="notaire_acquereur"
          control={control}
          defaultValue=""
          render={({field}) => (
            <SuggestionNotaire 
              label="Notaire acquéreur"
              objectField={field} 
              originalData={getValues('notaire_acquereur') || ""} 
            />
          )}
        />
        {FieldList.slice(4).map(
          (field, index) => getFormField(control, field, index)
        )}
      </div>
    </>
  )
}

export default ({ title = "", onClose = () => {}, onSuccess = () => {} }) => (
  <SectionForm
    title={title}
    onClose={onClose}
    onSuccess={onSuccess}
    fields={FieldList.map( f => f.name)}
    addToSubmitFields={["acquereurs", "notaire_vendeur", "notaire_acquereur"]}
  >
    <FormContent />
  </SectionForm>
)